import HospitalizationModal from './HospitalizationModal';

export default HospitalizationModal;
